import { computed, unref } from 'vue';

import { toTraitId } from '~/modules/latchkey/utils/utils';
import { useProductType } from '~/composables/useProductType';
import { useInitPrice } from '../../price/composables/mcl-utils/useInitPrice';
import { usePrice } from '../../price/composables/mcl-utils/usePrice';
import { usePriceParser } from '../../price/composables/mcl-utils/usePriceParser';
import type { Color, Size } from '~/declaration/traits';

function useInitEachSize(id: ProductId, product: Product, initialSelectedLatchkey: LatchkeyName, latchkeyNames: LatchkeyName[]) {
  const latchKeyLastIndex = latchkeyNames.length - 1;
  const productRelationships = product?.relationships ?? {};

  latchkeyNames.forEach((latchkeyName, index) => {
    productRelationships.selectedLatchKey = latchkeyName; // TO DO -> refactor a less hacky solution
    useInitPrice({ id: toTraitId(id, latchkeyName), data: usePriceParser(product) });
    if (index === latchKeyLastIndex) {
      // TO DO -> refactor a less hacky solution
      productRelationships.selectedLatchKey = initialSelectedLatchkey;
    }
  });
}

export default function usePriceLatchkey({
  id,
  product,
  selectedLatchkey,
  latchkeyNames,
  selectedUpcId,
  selectedColor,
  selectedSize,
}: {
  id: ProductId;
  product: ComputedRef<Product>;
  selectedLatchkey: Ref<LatchkeyName>;
  latchkeyNames: LatchkeyName[];
  selectedUpcId: ComputedRef<UpcId | null>;
  selectedColor: WritableComputedRef<Color | null>;
  selectedSize: WritableComputedRef<Size | null>;
}) {
  const { isConsolidatedLatchKey } = useProductType();

  if (!isConsolidatedLatchKey) {
    return computed(() => null);
  }
  const traitId = computed(() => (selectedLatchkey.value ? toTraitId(id, selectedLatchkey.value) : ''));

  useInitEachSize(id, unref(product), unref(selectedLatchkey), latchkeyNames);

  const { selectedPrice } = usePrice({
    id: traitId,
    selectedUpcId,
    selectedColor,
    selectedSize,
  });

  return selectedPrice;
}
